/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import greyledLearn from '../../assets/images/grayledlearns.png';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-loading-skeleton/dist/skeleton.css';
import { Modal, ModalBody } from 'react-bootstrap';
import { CustomTooltip } from '../../shared/Tooltip';
import { ContentGreyboxes } from '../../Pages/SideBar';

const StudentSignupSidebar = ({ handleShowDialoguebox = () => {}, modalShow, mode, bookRol, sectionData, classDetail, sectionDetail }) => {
  const [modalShows, setModalShows] = useState(false);
  const { settings } = useSelector((state) => state.settings.settings);
  const emails = useSelector((state) => state.entities.instructors.instructors) || [];
  const { licenses } = useSelector((state) => state.entities.bookFelids.bookFields);

  const { book } = classDetail || {};
  const classDetails = sectionData?.classId || [];
  const current_license = licenses.find((item) => item.label === book?.license) || {};

  //Create Class States
  const emailsMap = {};
  for (const email of emails) {
    emailsMap[email.email] = email;
  }

  const handleClose = () => {
    setModalShows(false);
    // Your closing logic here...
  };

  return (
    <div className='h-100'>
      <div
        className={`cursor ${settings.siteMode === 'teach' ? 'left_side_bar teach custom_nav' : 'left_side_bar custom_nav'}`}
        style={{
          // paddingLeft: "24px",
          display: settings.bookMode ? 'none' : 'block',
        }}
      >
        <div
          className={`logo_wrap ${settings.siteMode === 'teach' ? 'd-flex' : ''}`}
          style={{
            marginBottom: '25.02px',
            height: '34px',
            justifyContent: 'start',
          }}
        >
          <img className='' src={greyledLearn} alt={'learn_picture'} />
        </div>

        <ul className='nav nav-tabs nav-justified' id='myTab' role='tablist'>
          <CustomTooltip position="top" content="No book assigned to class">
            <li className='nav-item cursor_default' role='presentation'>
              <button
                className='nav-link disabled'
                id='home-tab'
                data-bs-toggle='tab'
                data-bs-target='#Contents'
                type='button'
                role='tab'
                aria-controls='Contents'
                aria-selected='true'
              >
                Contents
              </button>
            </li>
          </CustomTooltip>
          <li className='nav-item' role='presentation'>
            <button
              className='nav-link active'
              id='classroom-tab'
              data-bs-toggle='tab'
              data-bs-target='#classroom'
              type='button'
              role='tab'
              aria-controls='profile'
              aria-selected='false'
            >
              classroom
            </button>
          </li>
        </ul>
        <div className='tab-content' id='myTabContent'>
          <div className='tab-pane fade show' id='Contents' role='tabpanel' aria-labelledby='Contents-tab'>
            <div className='Contents_tabs'>
              {/* <div className='tabs_content classroom_wrap' id='myContents'>
                {subTab === 'all' ? (
                  <div className='tab-pane fade show active custom_tabs_chapater' aria-labelledby='all-tab'>
                    {renderChapters()}
                  </div>
                ) : (
                  ''
                )}
                {subTab === 'activities' ? (
                  <div className='tab-pane fade show active' aria-labelledby='Activities-tab'>
                    {renderNewActivities()}
                  </div>
                ) : (
                  ''
                )}
              </div> */}
            </div>
          </div>
          <div className='tab-pane fade show active' id='classroom' role='tabpanel' aria-labelledby='classroom-tab'>
            <div className='tabs_content classroom_wrap cursor_default' style={{ overflowY: 'clip' }}>
              {(book?.title || book?.author) ? 
                <div className='class_room_box'>
                  <div className='class_room_img'>
                    <img src={book?.coverImage || book?.bookDetailCoverUrl} alt='class_rom_img' className='class_rom_img' />
                  </div>
                  <div className='class_room_content pdl-20'>
                    <div className='content_top'>
                      <h6 className='text-uppercase text-grey'>
                        You're reading: <span></span>
                      </h6>
                      <h5>{book?.title}</h5>
                      <p>Written by: {book?.author}</p>
                      <p>
                        {new Date(book?.createdAt)?.getFullYear?.() || new Date().getFullYear()}
                      </p>
                      <div className='copy_rights'>
                        {current_license?.img_url && <img src={current_license.img_url} alt='CC' />}
                        {current_license?.img_url2 && <img src={current_license.img_url2} alt='BY' />}
                        {current_license?.img_url3 && <img src={current_license.img_url3} alt='NC' />}
                      </div>
                    </div>
                  </div>
                </div>:
                <ContentGreyboxes noBookSelect={true} role="none" />
              }

              <div>
                <h5 className='classroom_heading mt-64'>your classroom</h5>

                <div style={{ overflowY: 'scroll', height: '56vh' }}>
                  <div className='spn_wrap mt-16'>
                    <div className='spn_inner'>
                      <div>
                        <div className='sidbar-mar'>
                          <div>
                            <h5 className='mb-12'>
                              {classDetails?.courseNumber}: {classDetails?.courseName}{' '}
                              <span>
                                {moment(classDetails?.startDate).format('MMM')} - {moment(classDetails?.endDate).format('MMM   YYYY')}
                              </span>
                            </h5>
                          </div>

                          <div className='section_class'>
                            <div className=''>
                              <div className='section_class_inner'>
                                <div className='contetn_class'>
                                  <h3>
                                    <span className=''>Instructor</span>
                                    <span
                                      style={{
                                        wordBreak: 'break-word',
                                      }}
                                    >
                                      {sectionData?.instructorEmails?.length > 0 && (
                                        <span className='fw-normal'>
                                          {(() => {
                                            const firstEmail = sectionData.instructorEmails[0].email;
                                            const name = emailsMap[firstEmail] ? `${emailsMap[firstEmail].firstName} ${emailsMap[firstEmail].lastName}` : firstEmail.split('@')[0];

                                            const displayName = name.length > 16 ? `${name.slice(0, 16)}...` : name;
                                            const moreCount = sectionData.instructorEmails.length - 1;

                                            return `${displayName}${moreCount > 0 ? ` +${moreCount} instructor${moreCount > 1 ? 's' : ''}` : ''}`;
                                          })()}
                                        </span>
                                      )}
                                    </span>
                                  </h3>

                                  <h3>
                                    <span className=''>Schedule</span>
                                    {classDetails?.schedule?.split(',').map((word) => word.trim()[0])} 10:30 am - 12:30 pm
                                  </h3>
                                </div>{' '}
                                <u></u>{' '}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <>
        {/* Your other content here... */}
        <Modal show={modalShows} onHide={handleClose} backdrop='static' className='modal fade custom_modal_not model_with' id='Not_yet' tabIndex='-1' aria-labelledby='Not_yetLabel' aria-hidden='true'>
          <div className='modal-width'>
            <ModalBody>
              <button onClick={handleClose} type='button' className='btn_close_modal' data-bs-dismiss='modal' aria-label='Close'>
                <img src='/assets/images/cross.png' alt='cross' />
              </button>
              <div className='modal-body modal_content_main_Wrap'>
                <div className='modal_content_box' style={{ marginLeft: '0px' }}>
                  <h1>not yet!</h1>
                  <p>Complete signup to see assignments, read the book and connect with other students in your class.</p>
                </div>
                <div className='btn_wrap_info' style={{ marginTop: '40px' }}>
                  {/* Customize the onClick event for this button */}
                  <button
                    type='button'
                    className='btn_black_theme'
                    // onClick={handleCustomClick}
                  >
                    Take me back to signup
                    {/* Take me back to signup */}
                  </button>
                  <button type='button' className='btn_outline_dark mt_24'>
                    I just want to read
                  </button>
                </div>
              </div>
            </ModalBody>
          </div>
        </Modal>
      </>
    </div>
  );
};

export default StudentSignupSidebar;
